module.exports = __webpack_public_path__ + "img/all-bg1.a45ee9cb.png";